import styled from "styled-components";

import { Img } from "@sso/ui/Img";

export const ProductCoverImg = styled.div<{ src: string }>`
  min-height: 55%;
  width: auto;

  background-image: url(${p => p.src});
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
`;

export const ProductLogoContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
`;

export const ProductLogoImg = styled(Img)`
  position: absolute;
  height: ${p => p.height || "60%"};
  width: auto;
  transform: scale(1);
  ${ProductCoverImg}:hover & {
    transform: scale(1.2);
  }
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
`;
